import { render, staticRenderFns } from "./SalesCalendar.vue?vue&type=template&id=36e852c0&"
import script from "./SalesCalendar.vue?vue&type=script&lang=js&"
export * from "./SalesCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports